<template>
    <view class="cus-collapse" :class="{ active: isExpanded }">
        <view class="collapse-header" @click="toggleCollapse">
            <text class="collapse-title">
                <slot name="title">{{ title }}</slot>
            </text>
            <cusButton class="collapse-icon">
                <text class="icon-text iconfont icon-jiantou" :class="{ 'is-expanded': isExpanded }"></text>
            </cusButton>
        </view>
        <view class="collapse-content" :class="{ 'is-expanded': isExpanded }">
            <slot></slot>
        </view>
    </view>
    <!-- 占位的白色间隔 -->
    <view class="place" style="height: 3px; background: #fff"></view>
</template>

<script setup>
    import { ref } from 'vue';
    const props = defineProps({
        title: {
            type: String,
            default: '标题'
        },
        defaultExpanded: {
            type: Boolean,
            default: false
        }
    });

    const isExpanded = ref(props.defaultExpanded);

    const toggleCollapse = () => {
        isExpanded.value = !isExpanded.value;
    };

    const expand = () => {
        isExpanded.value = true;
    };

    const collapse = () => {
        isExpanded.value = false;
    };

    defineExpose({
        expand,
        collapse,
        isExpanded
    });
</script>

<style lang="scss" scoped>
    .cus-collapse {
        width: 100%;
        height: 46px;
        margin-bottom: 3px;
        background-color: #fff;
        // border-bottom: 3px solid #fff;
        // overflow: hidden;
        transition: all 0.1s ease;
        &.active {
            // height: 100%;
            height: fit-content !important;
            transition: height 0.3s ease;
        }

        .collapse-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 16px;
            cursor: pointer;
            position: sticky;
            top: -2px;
            transition: background-color 0.3s ease;
            color: #333;
            background: #ffeed6;
            z-index: 2;
            &:active {
                background-color: #f5f5f5;
            }

            .collapse-title {
                line-height: 23px;
                font-size: 20px;
                color: #000;
                font-weight: 600;
                width: 100%;
            }

            .collapse-icon {
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;

                .icon-text {
                    font-size: 24px;
                    color: #666;
                    transition: transform 0.3s ease;
                    &.is-expanded {
                        transform: rotate(-180deg);
                    }
                }
            }
        }

        .collapse-content {
            max-height: 0;
            height: calc(100% - 46px);
            overflow: hidden;
            transition: max-height 0.3s ease;

            &.is-expanded {
                max-height: 100%;
            }

            .content-inner {
                border-top: 1px solid #f0f0f0;
            }
        }
    }
</style>
